import { z } from 'zod';

/** Adults (D44, T-006): 18+ categories and «18+» events need this age when the age gate is on. */
export const ADULT_AGE = 18;
/** Teens-only events (created by a 14–17 organizer) are capped at this age. */
export const TEEN_MAX_AGE = ADULT_AGE - 1;
/** «Мінімальний вік» chips an organizer can pick; none = the app minimum (APP_MIN_AGE). */
export const MIN_AGE_OPTIONS = [16, 18] as const;

/** Oldest birth date we accept, as an age in years (typos like 1092 are rejected). */
export const MAX_AGE_YEARS = 120;

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** `YYYY-MM-DD` that is a real calendar date (no 2026-02-30). */
export const isoDateSchema = z.string().refine((value) => {
	const match = ISO_DATE.exec(value);
	if (match === null) return false;
	const [, y, m, d] = match.map(Number);
	const date = new Date(Date.UTC(y ?? 0, (m ?? 0) - 1, d ?? 0));
	return date.getUTCFullYear() === y && date.getUTCMonth() + 1 === m && date.getUTCDate() === d;
}, 'must be a real date as YYYY-MM-DD');

/** Today's date (`YYYY-MM-DD`) in `timeZone`. */
export function isoDateIn(now: Date, timeZone: string): string {
	return new Intl.DateTimeFormat('en-CA', {
		timeZone,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).format(now);
}

/** Full years between two `YYYY-MM-DD` dates. A 29 Feb birthday counts on 1 March. */
export function ageOn(birthDate: string, today: string): number {
	const [by = 0, bm = 0, bd = 0] = birthDate.split('-').map(Number);
	const [ty = 0, tm = 0, td = 0] = today.split('-').map(Number);
	const hadBirthday = tm > bm || (tm === bm && td >= bd);
	return ty - by - (hadBirthday ? 0 : 1);
}
